import * as cache from '@util/localCache';
import axios from 'axios';
import _ from 'lodash';

export const getAgencyTree = () => {
  return new Promise((resolve, reject) => {
    if (cache.getItem('agency_tree')) {
      return resolve(cache.getItem('agency_tree'));
    } else {
      axios.get('/hq-agency/user/agency_tree').then(res => {
        if (res.code === 200) {
          let agency = res.data.map(item => {
            return {
              pid: item.pid,
              id: item.id,
              name: item.name,
              hotelId: item.hotelId,
              type: item.type
            };
          });
          cache.setItem('agency_tree', agency);
          return resolve(_.cloneDeep(agency));
        }
      }).catch(error => {
        reject(error);
      });
    }
  });
};

export const getCutOffTime = () => {
  return axios.get('/crm-api/apollo-web/hotelInfo/accountantRecord').then(res => {
    return res.data;
  });
};
//存储卡类型
// export const getCardType = () => {
//   axios.post('/crm-api/eos-api-web/card-type/query-type-simple',{}).then((res)=>{
//     if (res.code = 200){
//       localStorage.setItem('cardType',JSON.stringify(res.data));
//       console.log(localStorage.cardType);
//     }
//   });
// };





// WEBPACK FOOTER //
// ./src/service/api.js